export class Watchlist {
	id: number;
	email: string;
	telephone: string;
	reason: string;
	hostUser: string;
	createdDate: Date;
	updatedDate: Date;
}
